//TODO: refactor with better approach this
export const isPopoverOutOfFocus = (target: EventTarget | null): boolean =>
  !(target as HTMLElement).classList.contains('info-icon-button');
